import { aboutImage } from "@/mocks/images";
import { about } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";

export default function About() {
  return (
    <section id="sobre" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">Sobre</p>
          <h2 className="mt-3 max-w-2xl font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-5xl">
            {about.title}
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal className="lg:sticky lg:top-32 lg:self-start">
            <div className="relative">
              <div className="absolute -right-3 -top-3 h-full w-full rounded-lg border border-accent-400/40 md:-right-5 md:-top-5" />
              <div className="relative">
                <img
                  src={aboutImage}
                  alt="Dra. Sâmia Albuquerque — retrato profissional"
                  title="Dra. Sâmia Albuquerque — retrato profissional"
                  className="relative w-full rounded-lg border border-accent-400/40 object-cover object-top aspect-[4/5]"
                />
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <div className="space-y-5 text-base leading-relaxed text-foreground-400 md:text-lg">
                {about.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </Reveal>

            <Reveal delay={100}>
              <div className="mt-8 border-l-2 border-accent-500 bg-secondary-200/40 px-6 py-6">
                <p className="font-heading text-xl italic leading-relaxed text-foreground-200 md:text-2xl">
                  {about.quote}
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {about.highlights.map((h, i) => (
            <Reveal key={h.label} delay={i * 100}>
              <div className="flex h-full items-center gap-4 rounded-lg border border-secondary-300 bg-background-100 p-6">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-500/15 text-accent-400">
                  <i className="ri-check-line text-xl" />
                </span>
                <div>
                  <p className="font-heading text-2xl font-semibold text-accent-400">{h.value}</p>
                  <p className="text-sm text-foreground-400">{h.label}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}